"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTypeClassMap = void 0;
exports.BcDataTypeClassMap = {
    id: 'bc-data-table-thead-id',
    number: 'bc-data-table-thead-number',
    string: 'bc-data-table-thead-string',
    date: 'bc-data-table-thead-date',
    money: 'bc-data-table-thead-money',
    action: 'bc-data-table-thead-action',
    checkAll: 'bc-data-table-thead-check-all',
    check: 'bc-data-table-thead-check',
    radio: 'bc-data-table-thead-radio',
    actions: 'bc-data-table-thead-actions',
    actionHeader: 'bc-data-table-thead-action-header',
    boolean: 'bc-data-table-thead-boolean',
    franchise: 'bc-data-table-thead-franchise',
    label: 'bc-data-table-thead-label',
    link: 'bc-data-table-thead-link',
    status: 'bc-data-table-thead-status',
};
